import React from "react";
import { Box, SpaceBetween } from "@cloudscape-design/components";

const FinanceSalaryAnnualEntriesHelp = () => (
  <SpaceBetween size="m">
    <Box>
      <strong>Annual entry table</strong>
      <p>Each row represents one province, territory or NWAC National for the selected fiscal year.</p>
    </Box>
    <Box>
      <strong>Assigned pot</strong>
      <p>Select the budget pot that should carry the annual salary commitment for that region and fiscal year.</p>
    </Box>
    <Box>
      <strong>Annual salary</strong>
      <p>Enter the full annual salary commitment and save. Budgets includes this amount as Committed, and Budget Overview spreads it evenly across twelve months.</p>
    </Box>
  </SpaceBetween>
);

FinanceSalaryAnnualEntriesHelp.aiContext =
  "Explain the annual salary entry table: one row per province, territory or NWAC National; explicit pot assignment within the selected fiscal year; annual salary commitment; even monthly amounts; and save workflow. Saved annual salaries count as Committed in Budgets and Budget Overview, not recorded payroll payments. Financial Reports contains client funding only.";

export default FinanceSalaryAnnualEntriesHelp;
